import { useState } from "react";

import Box from "@/components/Box";
import { ExternalTextLink } from "@/components/Links";
import OnboardingStatusChecker from "@/components/notifications/ui/OnboardingStatusChecker";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import Danger from "@/images/Danger";
import ChevronComponent from "@/tpo/Chevron";
import Spacer from "@/tpo/Spacer";
import ButtonV2 from "@/v2/Buttons";

import StripeCalloutBanner from "./StripeCalloutBanner";

function Header() {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={16}>
      <Danger size={40} />
      <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight="46px" color="#1A1A1A">
        Additional details required
      </Box>
    </Box>
  );
}

function Body({ missingRequirements = [] }) {
  const { organisation } = useOrganisationContext();
  const [checkingStatus, setCheckingStatus] = useState(false);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      maxWidth={720}
      mx="auto"
      width="100%"
    >
      <Box alignSelf="stretch">
        <Spacer py={14} />
        <Box fontFamily="gilroyMedium" fontSize={16} lineHeight="28px" color="#1A1A1A">
          Stripe needs some extra information to verify your account before payments can be
          processed. This information is collected securely by Stripe and is required before payouts
          can be enabled.
        </Box>
      </Box>
      {missingRequirements.length > 0 && (
        <>
          <Spacer py={14} />
          <Box alignSelf="stretch">
            <Box as="ul" pl={20} fontFamily="gilroyMedium" fontSize={16} lineHeight="28px" color="#1A1A1A">
              {missingRequirements.map((requirement, index) => {
                const parts = requirement.split(": ");
                const label = parts[0];
                const detail = parts.slice(1).join(": ");
                return (
                  <Box as="li" key={index} lineHeight={1.8}>
                    <Box as="span" fontFamily="gilroyBold">{label}</Box>
                    {detail && <Box as="span">: {detail}</Box>}
                  </Box>
                );
              })}
            </Box>
          </Box>
        </>
      )}
      <Spacer py={20} />
      <Box alignSelf="stretch">
        <Box fontFamily="gilroyBold" fontSize={18} lineHeight="28px" color="#000000">
          Payment provider
        </Box>
      </Box>
      <Spacer py={15} />
      <Box alignSelf="stretch">
        <StripeCalloutBanner fontSize={14} />
      </Box>
      <Spacer py={20} />
      <ButtonV2
        as={ExternalTextLink}
        href={organisation?.onboardingUrl}
        target="_self"
        rel="noopener noreferrer"
        color="green"
        rightIcon={<ChevronComponent opacity={checkingStatus ? 0 : 1} />}
        type="button"
        size={["sm", "sm", "md"]}
        underline={false}
      >
        Complete Setup
        <OnboardingStatusChecker onChange={active => setCheckingStatus(active)} />
      </ButtonV2>
    </Box>
  );
}

export default Object.assign(
  {},
  {
    Header,
    Body,
  }
);
